import {
  FontDecorators,
  ThemeDecorators,
  ThemeProviderDecorators,
} from "@/shared-web.ui/themes";

interface ThemeProviderProps {
  children: React.ReactNode;
}
const ThemeProvider = (props: ThemeProviderProps) => {
  const { children } = props;
  return (
    <FontDecorators>
      <ThemeProviderDecorators>
        <ThemeDecorators>
          {children}
        </ThemeDecorators>
      </ThemeProviderDecorators>
    </FontDecorators>
  );
};

export {
  ThemeProvider,
};
